import { Breadcrumb } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import React from "react";
const BreadcrumbComponent = React.forwardRef(
  ({ title = "", parentTitle = "" }, ref) => {
    return (
      <div>
        <Breadcrumb
          style={{ paddingBottom:"10px", borderRadius:"5px",textTransform:"uppercase"}}
          items={[
            {
              href: "/home",
              title: <HomeOutlined />,
            },
            {
              href: "",
              title: (
                <>
                  <span>{parentTitle}</span>
                </>
              ),
            },
            {
              title: <>{title}</>,
            },
          ]}
        />
      </div>
    );
  }
);
export const BreadcrumbComp = React.memo(BreadcrumbComponent);
